/** Трио маски фото-рамки, оба написания персиста (drawable v0 / `box.params` v1); фон и декор — не носители этого трио. */
export interface ImageMaskFields {
  readonly maskRect?: import('@lite-workspace/dto-fotoclass-templates').BoxMaskRect;
  readonly maskDataUrl?: string;
  readonly maskUrl?: string;
  readonly maskFileId?: string;
}

type WithoutMaskFields<T extends ImageMaskFields> = Omit<T, 'maskDataUrl' | 'maskUrl' | 'maskFileId' | 'maskRect'>;

// A pick writes `maskDataUrl` — the only field renderers read, http or inline — and drops the template's `maskUrl`/`maskFileId`
// pair, which would else restore the old mask; re-picking a worn mask returns `null` to spare an undo step, save and re-bake.
export function nextImageMaskFields<T extends ImageMaskFields>(
  fields: T,
  maskUrl: string | null,
): (WithoutMaskFields<T> & { readonly maskDataUrl?: string }) | null {
  if (
    fields.maskRect === undefined &&
    fields.maskUrl === undefined &&
    fields.maskFileId === undefined &&
    (fields.maskDataUrl ?? null) === maskUrl
  ) {
    return null;
  }

  const { maskDataUrl: _inline, maskUrl: _url, maskFileId: _file, maskRect: _frame, ...rest } = fields;

  return maskUrl === null ? rest : { ...rest, maskDataUrl: maskUrl };
}
